import apiClient from '@/api/client';

export const PartnerService = {
    async getAll(): Promise<GetAllPartnersResponse> {
        const response = await apiClient.get<GetAllPartnersResponse>('/partners');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve partners.');
        }

        return result;
      },

    async update(id: number, name: string) {
        const response = await apiClient.put(`/partners/${id}`, {
          name: name
        });

        if (response.status != 200) {
            throw new Error('Failed to update partner.');
        }
    },

    async delete(id: number) {
      const response = await apiClient.delete(`/partners/${id}`);

      if (response.status != 204) {
          throw new Error('Failed to delete partner.');
      }
    }
}

export interface GetAllPartnersResponse {
    partners: Partner[]
}

export interface Partner {
  id: number
  name: string
}